var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSecure',[_c('h1',{staticClass:"my-6 text-center",attrs:{"lang":_vm.lang}},[_vm._v(" "+_vm._s(_vm.$t('trans.history.submissnHistory'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }